export default function Marquee() {
  const items = [
    "Powerlifting",
    "Olympic Lifting",
    "Bodybuilding",
    "Strongman",
    "CrossFit-Style",
    "Open Gym",
    "Beginners Welcome",
    "Personal Records",
    "Quality Iron",
    "Community First",
  ];

  const track = [...items, ...items];

  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-white/10 bg-[#0055FF] overflow-hidden"
      aria-label="Training styles welcome"
    >
      <div className="flex whitespace-nowrap marquee-track py-5">
        {track.map((label, i) => (
          <div
            key={i}
            className="flex items-center gap-6 px-6"
            data-testid={`marquee-item-${i}`}
          >
            <span className="font-heading font-extrabold uppercase tracking-tight text-2xl md:text-3xl text-white">
              {label}
            </span>
            <span className="w-2 h-2 bg-white/80 rotate-45" />
          </div>
        ))}
      </div>
    </section>
  );
}
